import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ILawFirm } from '../interface/LawFirm/ILawFirm';
import { ILawFirmFilter } from "../interface/LawFirm/ILawFirmFilter";
import { IFidc } from '../interface/IFidc';
import { ILawFirmCostControll } from "../interface/LawFirm/ILawFirmCostControll";

enum LawFirmServiceEnum {
  baseUrl = "/",
  get = "/get-all-category",
  getWithLogoById = "/get-with-logo/",
  saveFilter = "/save-filter/",
  fidcList = "/",
  costControll = "/cost-controll",
  costControllByLawFirm = "/cost-controll/",
}

export default class LawFirmService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/law-firm");
  }

  public getAll = async (): Promise<ILawFirm[]> => await this.GET(LawFirmServiceEnum.baseUrl);
  public getById = async (id): Promise<ILawFirm> => await this.GET(LawFirmServiceEnum.baseUrl + id);
  public getWithLogoById = async (id): Promise<ILawFirm> => await this.GET(LawFirmServiceEnum.getWithLogoById + id);
  public save = async (data): Promise<ILawFirm> => await this.POST(LawFirmServiceEnum.baseUrl, data);
  public saveFilter = async (data: ILawFirmFilter[], id: number): Promise<ILawFirmFilter[]> => await this.POST(LawFirmServiceEnum.saveFilter + id, data);
  public getFidc = async (): Promise<IFidc[]> => await this.GET(LawFirmServiceEnum.fidcList);
  public getCostControllByLawFirmId = async (lawFirmId: number): Promise<ILawFirmCostControll[]> =>
    await this.GET(LawFirmServiceEnum.costControllByLawFirm + lawFirmId);
  public saveCostControll = async (data: ILawFirmCostControll): Promise<ILawFirmCostControll> =>
    await this.POST(LawFirmServiceEnum.costControll, data);
}
